import { useRef, useState } from 'react';
import './startDaySelection.scss';
import Calender from '../../../assets/icons/calendar.svg';

const StartDaySelection = () => {
  const [startDate, setStartDate] = useState<string>('');
  const calendarRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (calendarRef.current) calendarRef.current?.showPicker();
  };

  return (
    <div className="startDaySelectionComponent">
      <div className="dateLabel">
        {startDate} {startDate == '' ? '' : '~ 계속'}
      </div>
      <input
        ref={calendarRef}
        type="date"
        style={{ visibility: 'hidden', width: '0px' }}
        onChange={(e) => {
          setStartDate(String(e.target.value).replace('-', '.').replace('-', '.'));
        }}
      />
      <img src={Calender} alt="" className="calenderImage" onClick={handleButtonClick} />
    </div>
  );
};

export default StartDaySelection;
